import { createFileRoute, notFound } from "@tanstack/react-router";
import { templatePreviewHead } from "../components/template-preview/head";
import { TemplatePreviewPage } from "../components/template-preview/template-preview-page";
import { keepSearch, searchText } from "../lib/search";
import { loadTemplatePreview } from "../server/template-preview";

/**
 * A template's example home (/use-cases/<slug>/preview), which onboarding frames and template
 * demo hosts serve: the template's own page document, filled with its illustrative example.
 */
export const Route = createFileRoute("/use-cases/$slug_/preview/")({
  validateSearch: keepSearch,
  loaderDeps: ({ search }) => ({
    theme: searchText(search, "theme"),
    look: searchText(search, "look"),
    hero: searchText(search, "hero") === "1",
  }),
  loader: async ({ params, deps }) => {
    const preview = await loadTemplatePreview({
      data: { slug: params.slug, page: "", theme: deps.theme, look: deps.look, hero: deps.hero },
    });
    if (!preview) throw notFound();
    return preview;
  },
  head: ({ loaderData }) => templatePreviewHead(loaderData),
  component: TemplatePreview,
});

function TemplatePreview() {
  return <TemplatePreviewPage preview={Route.useLoaderData()} />;
}
